// ============================================================
// Planos do Templus — fonte única de verdade (mensalidade por porte da igreja).
// Edite os valores aqui; Landing e "Minha Igreja" leem deste arquivo.
//
// São 3 planos (valores definidos pelo cliente). O sufixo varia por plano.
// ============================================================

export const PLANOS = [
  { id: 'p1', faixa: '0 a 100 membros',     subtitulo: 'Para igrejas pequenas',      min: 0,    max: 100,  valor: 49.90,  sufixo: '', popular: false },
  { id: 'p2', faixa: '401 a 600 membros',   subtitulo: 'Para igrejas em crescimento', min: 401,  max: 600,  valor: 199.90, sufixo: '/mês',           popular: true },
  { id: 'p3', faixa: '1000 a 2500 membros', subtitulo: 'Para igrejas grandes',         min: 1000, max: 2500, valor: 799.80, sufixo: '/mês',           popular: false },
]

// Recursos inclusos em todos os planos (exibidos nos cards da Landing).
export const RECURSOS_PLANO = [
  'Membros, Redes e Células',
  'Escola Bíblica & Kids com check-in',
  'Eventos e inscrições',
  'Voluntários e ministérios',
  'Links públicos de cadastro',
  'Relatórios e dashboard',
]

// Formata um valor numérico como moeda BRL. Retorna "Sob consulta" quando null.
export function formatBRL(valor) {
  if (valor === null || valor === undefined) return 'Sob consulta'
  return 'R$ ' + Number(valor).toFixed(2).replace('.', ',')
}

// Encontra o plano pelo id.
export function planoPorId(id) {
  return PLANOS.find(p => p.id === id) || null
}
